import React, { Component } from 'react';
import * as yup from 'yup';

import Modal, {
  ModalAction,
  ModalBody,
  ModalButton,
  ModalHeader,
} from '../../../../components/Modal/Modal';
import { trans } from '../../../../localization/index';
import WalletBasicInfo from '../components/WalletBasicInfo';
import {
  clearSpecialCharacters,
  isEmpty,
  validateEmail,
  validatePhone,
} from '../../../../utils/utils';
import {
  EnumWalletServiceType,
  findEnumById,
} from '../../../../constants/enum';

const stateData = {
  ownerName: '',
  ownerPhone: '',
  ownerEmail: '',
  idCardNumber: '',
  address: '',
  maskServiceTypes: {
    label: EnumWalletServiceType.ALL.label,
    value: EnumWalletServiceType.ALL.id,
  },
  isSubmit: false,
};

export function getValueChangeWallet(valueOld, valueNew) {
  return valueNew !== valueOld ? valueNew : '';
}

class UpdateWalletModal extends Component {
  state = stateData;

  componentDidUpdate(prevProps) {
    this.handleOpenDialog(prevProps);
  }

  handleOpenDialog = (prevProps = {}) => {
    const { isOpenDialog } = this.props;
    const { isOpenDialog: oldIsOpenDialog } = prevProps;
    // check change state from close -> open
    if (!oldIsOpenDialog && isOpenDialog) {
      this.resetState();
    }
  };

  resetState = () => {
    const { walletItem } = this.props;
    const {
      address,
      owner_email: ownerEmail,
      owner_name: ownerName,
      owner_phone: ownerPhone,
      id_card_number: idCardNumber,
      mask_service_types: maskServiceTypes = EnumWalletServiceType.ALL.id,
    } = walletItem;
    const stateReset = {
      ...stateData,
      ownerName,
      ownerPhone,
      ownerEmail,
      idCardNumber,
      maskServiceTypes: findEnumById(EnumWalletServiceType, maskServiceTypes),
      address,
    };
    this.setState(stateReset);
  };

  handleChangeInput = stateObj => {
    this.setState(stateObj);
  };

  handleUpdateWallet = () => {
    const {
      updateUserWallet,
      airpayStoreId,
      setGeneralError,
      walletItem,
    } = this.props;
    this.setState({
      isSubmit: true,
    });

    function validate(reqParam, dispatchGeneralError) {
      const { ownerPhone } = reqParam;
      const requiredMessage = trans(
        'merchant_wallet_required_fill_information',
      );
      const schema = yup.object().shape({
        ownerName: yup
          .string()
          .required(requiredMessage)
          .test(
            'len',
            trans('mwl_invalid_owner_name'),
            val => val.length >= 2 && val.length <= 100,
          ),
        ownerPhone: yup.string().required(requiredMessage),
        ownerEmail: yup
          .string()
          .required(requiredMessage)
          .test('email', trans('mwl_invalid_email'), validateEmail)
          .test('len', trans('mql_invalid_email'), val => val.length <= 100),
        idCardNumber: yup
          .string()
          .required(requiredMessage)
          .test(
            'len',
            trans('mwl_invalid_card_number'),
            val => val.length >= 2 && val.length <= 16,
          ),
        address: yup
          .string()
          .required(requiredMessage)
          .test(
            'len',
            trans('mwl_invalid_address'),
            val => val.length >= 10 && val.length <= 100,
          ),
      });
      try {
        schema.validateSync(reqParam);
        if (!validatePhone(ownerPhone)) {
          dispatchGeneralError('merchant_phone_invalid');
          return false;
        }
        return true;
      } catch (err) {
        dispatchGeneralError(err.message);
        return false;
      }
    }

    function genBody(state) {
      const {
        address: addressOld,
        owner_email: ownerEmailOld,
        owner_name: ownerNameOld,
        owner_phone: ownerPhoneOld,
        id_card_number: idCardNumberOld,
        mask_service_types: maskServiceTypesOld,
      } = walletItem;
      const {
        ownerName,
        ownerPhone,
        ownerEmail,
        idCardNumber,
        address,
        maskServiceTypes,
      } = state;
      const ownerPhoneNew = clearSpecialCharacters(ownerPhone);
      const idCardNumberNew = clearSpecialCharacters(idCardNumber);
      const reqParam = {
        airpay_store_id: airpayStoreId,
        owner_name: getValueChangeWallet(ownerNameOld, ownerName),
        owner_phone: getValueChangeWallet(ownerPhoneOld, ownerPhoneNew),
        owner_email: getValueChangeWallet(ownerEmailOld, ownerEmail),
        id_card_number: getValueChangeWallet(idCardNumberOld, idCardNumberNew),
        address: getValueChangeWallet(addressOld, address),
        ...(!isEmpty(
          getValueChangeWallet(maskServiceTypesOld, maskServiceTypes.value),
        )
          ? {
              mask_service_types: maskServiceTypes.value,
            }
          : {}),
      };
      return reqParam;
    }
    if (validate(this.state, setGeneralError)) {
      const reqParam = genBody(this.state);
      updateUserWallet(reqParam);
    }
  };

  render() {
    const { isOpenDialog, closeDialogGeneric } = this.props;
    const {
      ownerName,
      ownerPhone,
      ownerEmail,
      idCardNumber,
      address,
      maskServiceTypes,
      isSubmit,
    } = this.state;
    return (
      <React.Fragment>
        <Modal
          isOpen={isOpenDialog}
          onRequestClose={closeDialogGeneric}
          className="edit-merchant-form"
        >
          <ModalHeader closeButton>
            {trans('merchant_wallet_update_user_wallet')}
          </ModalHeader>
          <ModalBody className="bg-control">
            <WalletBasicInfo
              ownerName={ownerName}
              ownerPhone={ownerPhone}
              ownerEmail={ownerEmail}
              idCardNumber={idCardNumber}
              address={address}
              isSubmit={isSubmit}
              maskServiceTypes={maskServiceTypes}
              handleChangeInput={this.handleChangeInput}
              required
            />
            <p className="label-warning">
              {trans('merchant_wallet_update_wallet_note')}
            </p>
          </ModalBody>
          <ModalAction>
            <ModalButton type="cancel" onClick={closeDialogGeneric}>
              {trans('common_close')}
            </ModalButton>
            <ModalButton styleType="red" onClick={this.handleUpdateWallet}>
              {trans('merchant_wallet_update')}
            </ModalButton>
          </ModalAction>
        </Modal>
      </React.Fragment>
    );
  }
}

export default UpdateWalletModal;



// WEBPACK FOOTER //
// ./foody/src/pages/MerchantWallet/WalletManagement/UpdateWallet/UpdateWalletModal.jsx